import { useRef, useState } from 'react'
import Popover from '@mui/material/Popover'
import {
  Link,
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import { makeStyles } from "@mui/styles";
import List from '@mui/material/List'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { NormalText } from './StyledComponent';

const FAQContent = {
  goods: [
    {
      group: 'Pre-Remate',
      questions: [
        {
          title: '¿Cómo participar en el remate?',
          answer:
            'Ingresar en opción PRÓXIMOS REMATES y luego en INCRIBIR GARANTÍA. Posteriormente solo basta con completar un breve formulario de inscripción y dejar una garantía acorde a la compra que desea realizar. Si no cuentas con un usuario en nuestra página, puedes crearlo directamente desde la opción REGÍSTRATE',
        },
        {
          title: '¿Cómo me inscribo?',
          answer:
            'Puedes inscribirse en forma directa a través de la opción REGÍSTRATE o bien ingresar a PRÓXIMOS REMATES y luego INCRIBIR GARANTÍA. Posteriormente solo basta con completar un breve formulario de inscripción',
        },
        {
          title: '¿Cómo ingreso al remate?',
          answer:
            'Debes estar previamente inscrito y con una garantía constituida y pagada al momento para poder ingresar al remate. Verás un recuadro habilitado en nuestra página de inicio el día del remate donde debes entrar e iniciar sesión con tu cuenta',
        },
        {
          title: '¿Cuáles son los costos al participar de un remate?',
          answer:
            'Al valor de adjudicación se le aplica el porcentaje de comisión + IVA de cada remate y además los gastos operacionales que se establecen en sus bases.',
        },
        {
          title: '¿Qué son los lotes con derecho?',
          answer:
            'Estos lotes son aquellos que tienen iguales características y precio mínimo, por lo que se puede fijar el precio en el primer lote y el comprador puede tomar más de estos al mismo valor si así lo desea.',
        },
        {
          title: '¿Existe financiamiento y cómo lo obtengo?',
          answer:
            'Existe crédito directo para clientes con cuenta corriente, plazo a 12 meses, por montos superiores a M$5.000 y bienes que sean sujetos a prenda. Solicitar información con Daniela Rojas al correo drojas@tattersall.cl con a lo menos 3 días de anticipación al remate.',
        },
        {
          title: '¿Hay facilidad de carguío?',
          answer:
            'Depende del remate y la zona en la cual se encuentren los bienes. Información establecida en las bases de cada remate.',
        },
        {
          title: '¿Me pueden despachar a domicilio el vehículo que compré?',
          answer:
            'Sí, podemos enviar a su domicilio el vehículo comprado, sin embargo, esto se acogerá a las condiciones en las que se encuentre el bien. En las bases se establecen los costos aproximados asociados para Santiago y Regiones.',
        },
      ],
    },
    {
      group: 'Garantía',
      questions: [
        {
          title: '¿Qué es una garantía?',
          answer:
            'Es un depósito efectuado a Tattersall Gestión de Activos por un monto establecido en las bases para garantizar la seriedad de ofertas y participación del comprador.',
        },
        {
          title: '¿Cómo pago la garantía?',
          answer:
            'La garantía se puede constituir en nuestra página WEB una vez que has iniciado sesión con tu perfil. Las modalidades de pago son PAGO FÁCIL (WEBPAY, MACH, etc.) y depósito en efectivo o transferencia electrónica a la cuenta corriente Banco BCI Nro. 10634347 a nombre de Tattersall Gestión de Activos S.A., Rut 96.775.780-2',
        },
        {
          title: '¿Cuál es el monto mínimo de garantía?',
          answer:
            'El monto varía acorde al remate y su valor está estipulado en las bases.',
        },
        {
          title:
            'Si no adjudico, ¿en cuántos días me devuelven la garantía depositada?',
          answer:
            'El proceso de devolución de garantías comienza a partir del quinto día hábil bancario después de finalizado el remate',
        },
        {
          title:
            'Si deposito como garantía un monto inferior al mínimo requerido, ¿puedo participar del remate con ese valor?',
          answer:
            'No se puede participar con un valor que esté por debajo de la garantía mínima establecida para el remate en las bases.',
        },
        {
          title:
            '¿Cuánto demora el proceso de habilitación para participar del remate si ya pagué la garantía?',
          answer:
            'Si pagaste a través de depósito en efectivo o transferencia y subiste el comprobante de pago al momento de inscribir la garantía, el departamento de Finanzas valida la información y habilita de manera inmediata en horarios hábiles.',
        },
      ],
    },
    {
      group: 'Remate',
      questions: [
        {
          title: '¿Qué son las bases del remate y dónde las puedo leer?',
          answer:
            'Las Bases son las condiciones que regulan la venta en remate y establecen obligaciones para comprador y vendedor previa a la participación del remate. Estas están publicadas en cada uno de los lotes.',
        },
        {
          title:
            'Si ya adjudiqué lo que planeaba comprar, ¿cuál es el siguiente paso que debo hacer?',
          answer:
            'El proceso posterior al finalizar un remate es la facturación. Se facturará con los datos de la inscripción y se le enviará el documento al correo que quedó registrado en el perfil del usuario.',
        },
        {
          title:
            '¿Qué es la comisión de martillo que se cobra sobre el valor de adjudicación?',
          answer:
            'La comisión es el costo aplicado a la adjudicación más IVA sobre el valor final martillo al lote y será de cargo exclusivo del comprador. Los porcentajes están establecidos en las bases de cada remate.',
        },
      ],
    },
    {
      group: 'Post Venta',
      questions: [
        {
          title: '¿Cuándo puedo retirar lo que compré?',
          answer:
            'Los días para la entrega están establecidos por bases y el contacto de la persona a cargo con quien se debe coordinar.',
        },
        {
          title: '¿Qué documentos debo llevar para el retiro?',
          answer:
            'Para el retiro de Bienes debes asistir con copia de la factura impresa y para el caso de Vehículos validar en bases los documentos requeridos según corresponda TAG o carta de cesión firmada.',
        },
        {
          title: '¿A qué cuenta debo pagar el saldo de la factura?',
          answer:
            'En la cuenta corriente Nº 10634347, del Banco Bci a nombre de Tattersall Gestión de Activos S.A., Rut 96.775.780-2',
        },
        {
          title: '¿Qué documentación necesito para retirar dispositivos TAG?',
          answer:
            'Persona Natural: debe presentar Cédula de Identidad. / Persona Jurídica: debe presentar copia de rol único tributario o copia de escritura pública y cédula de identidad de la persona natural que la representa.',
        },
        {
          title:
            '¿Es necesario que me entreguen dispositivo TAG si no soy de Santiago?',
          answer:
            'Sí, quien participe de nuestros remates y adjudique vehículos con patente deberá tener su dispositivo TAG correspondiente.',
        },
        {
          title: '¿Dónde puedo ver el estado de mi transferencia?',
          answer:
            'Para consultar por el estado de tu transferencia, puedes enviar un correo a transferenciasGDA@tattersall.cl.',
        },
      ],
    },
  ],
  props: [
    {
      group: 'Preguntas Frecuentes',
      questions: [
        {
          title: '¿Como puedo participar de un Remate?',
          answer: `Es muy fácil, solo debes seguir los siguientes pasos que a continuación detallamos: 
        •	Pincha la palabra “REGISTRATE” que está en el extremo superior de nuestra página (tattersalltga.cl) y registra tus datos.
        •	Una vez ingresado, selecciona la propiedad en que estas interesado y pincha el botón “INSCRIBETE AQUÍ” 
        •	Pincha la “CARTA OFERTA” y envíanos de tu oferta y constitución de la garantía.
        •	Ojo, para constituir la garantía solo debes depositar, transferir o pagar vía web pay a las cuentas de TGDA el 10 % del mínimo de la propiedad que te interesa. 
        •	Si te la adjudicas, este monto se abonará automáticamente al precio de tu compra, sin generar reajustes ni intereses. 
        Ahora, participa activamente, ¡a través del sistema Online!
        `,
        },
        {
          title:
            '¿Qué pasa cuando baja el martillo y me adjudique la propiedad?',
          answer: `Al adjudicarte un lote, nuestro sistema realizara el proceso de “cierre de negocios” (formalizando tu compra). Para ello nuestro equipo te llamara y guiara paso a paso. Este trámite debes realizarlo dentro de los 3 días hábiles siguientes al remate donde deberás:  Firmar el Acta de Adjudicación y pagar la comisión de martillo, honorarios de abogados por el control de las adjudicaciones y los fondos a rendir para inscribir la compraventa en el CBR.`,
        },
        {
          title: '¿Dónde se paga el saldo de precio por la propiedad?',
          answer: `El pago de la adjudicación debes realizarlo directamente en Tattersall GDA. 
        En caso de que las propiedades estén afectas a IVA, este impuesto es de cargo del comprador, y no se considerará parte del precio de adjudicación o “valor martillo”.`,
        },
        {
          title: '¿Qué alternativas tengo para pagar el saldo de precio?',
          answer: `Los pagos se pueden realizar de 3 formas: 

        1. Vale vista, dejado con instrucciones notariales, si el mandante lo permite, al momento de suscribir la compraventa. 
        2. Pago mediante web pay, este pago conlleva una comisión de transacción que es de cargo del comprador.
        3. Pago mediante transferencia o depósito bancario:  
        Estos pagos deben realizarse antes de la firma de la escritura, enviando el respaldo de esta transacción a Tattersall vía correo electrónico.
        `,
        },
        {
          title:
            '¿Cuánto se demoran en devolver la garantía en caso de no adjudicarme la propiedad?',
          answer: `Las garantías se devuelven dentro de los 5 días hábiles siguiente al remate. `,
        },
        {
          title: '¿Tiene financiamiento para la compra de una propiedad?',
          answer: `Son casos puntuales y solo permitidos en remates de particulares. En los remates Bancarios, de Liquidaciones Concursales y las Reorganizaciones, no se permiten financiamientos bancarios ni dejar instrucciones notariales para entregar el pago de la compraventa contra inscripción en el CBR.`,
        },
        {
          title: '¿Cómo es el proceso de escrituración de mi propiedad?',
          answer: `a-	Si el vendedor es un particular, los antecedentes para el estudio de títulos, son agrupados y entregados por él al departamento legal de Tattersall.
        b-	 Si la propiedad proviene de Bancos, Liquidaciones Concursales o Reorganizaciones, será el comprador quien deberá recopilar estos documentos. 
        
        Los plazos de notaria y Conservadores NO dependen de TATTERSALL y por lo mismo las bases sólo contemplan un plazo para la firma de la compraventa por parte del comprador. Para los demás trámites no se contempla un plazo, (ya que no está en nuestras manos). Los procesos de firma pueden ser más extensos, dependiendo de cuantas personas deban suscribir la compraventa, especialmente cuando existen alzamientos que deben firmarse por parte de instituciones. Por su parte las inscripciones en los CBR usualmente pueden tomar alrededor de 30 a 60 días hábiles dependiendo de cada Conservador. Este plazo debe contabilizarse desde que se envía al CBR y NO desde la fecha del REMATE. 
        `,
        },
        {
          title: '¿Cuándo se entrega propiedad comprada?',
          answer: `El comprador tomará posesión de la propiedad adjudicada, una vez inscrita en el CBR. Tattersall no participa de esta entrega. 
        En el caso de las propiedades “ocupadas”, la desocupación es de cargo del comprador.
        `,
        },
        {
          title:
            '¿Qué pasa con las deudas y contribuciones de las propiedades?',
          answer: `Para las propiedades que son ofrecidas en procesos de liquidación Concursal, Reorganizaciones y remates bancarios, el pago de las deudas de contribuciones y consumos básicos, será de cargo del comprador. `,
        },
      ],
    },
  ],
}

const useStyles = makeStyles((theme) => ({
  root: {},
  button: {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: 0.5,
    transition: 'color 0.2s',
    '&:hover': {
      color: theme.palette.info.main,
      textDecoration: 'underline',
    },
  },
  FAQContainer: {
    width: '100%',
    maxWidth: 500,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2.6),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 2px 16px 0 rgba(0,0,0,0.08)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '95vw',
      padding: theme.spacing(1),
    },
  },
  FAQText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 15,
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  FAQTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 17,
    fontWeight: 600,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  FAQSection: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 21,
    fontWeight: 'bold',
    color: theme.palette.info.main,
    letterSpacing: 0.5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 17,
    },
  },
  rootAreaSelect: {
    display: 'flex',
    gap: 1,
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2.6),
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('sm')]: {
      minWidth: '90vw',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  },
  areaButton: {
    minWidth: 150,
    color: 'white',
    padding: theme.spacing(1.5),
    fontWeight: 600,
    fontSize: 16,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    border: "1px solid white",
    transition: 'background 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.primary.main,
    },
  },
  withoutBorder: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflow: 'visible',
  },
  popoverScroll: {
    top: (props) => `calc(100vh - ${props.height}px)!important`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    overflowY: 'scroll',
  },
  accordion: {
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0 1px 6px 0 rgba(0,0,0,0.06)',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: '0 2px 12px 0 rgba(0,0,0,0.12)',
    },
  },
}))
export default function FAQAccordion() {
  const popoverRef = useRef()
  const [openButtons, setOpenButtons] = useState(false)
  const [isOpenFAQ, setIsOpenFAQ] = useState(false)
  const [FAQArea, setFAQArea] = useState('goods')
  const classes = useStyles({ height: popoverRef.current?.clientHeight })
  const handleClickLink = (event) => {
    setOpenButtons(event.currentTarget)
  }
  const handleClickArea = (event, area) => {
    setOpenButtons()
    setIsOpenFAQ(document.getElementById('frecuentes'))
    setFAQArea(area)
  }
  const handleCloseArea = () => {
    setOpenButtons()
  }
  const handleCloseFAQ = () => {
    setOpenButtons()
    setIsOpenFAQ()
  }

  return (
    <>
      <Link
        id="frecuentes"
        type="button"
        className={classes.button}
        aria-describedby="preguntas"
        onClick={handleClickLink}
      >
        <NormalText color={'#ECECEC'}>
          PREGUNTAS FRECUENTES
        </NormalText>
      </Link>
      <Popover
        ref={popoverRef}
        classes={{ paper: classes.withoutBorder }}
        open={openButtons}
        anchorEl={openButtons}
        marginThreshold={0}
        onClose={handleCloseArea}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box className={classes.rootAreaSelect}>
          <Button
            onClick={(e) => handleClickArea(e, 'goods')}
            className={classes.areaButton}
          >
            Bienes
          </Button>
          <Button
            onClick={(e) => handleClickArea(e, 'props')}
            className={classes.areaButton}
          >
            Propiedades
          </Button>
        </Box>
      </Popover>
      <Popover
        id="FAQPopover"
        classes={{ paper: classes.popoverScroll }}
        open={isOpenFAQ}
        anchorEl={isOpenFAQ}
        marginThreshold={0}
        onClose={handleCloseFAQ}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <List className={classes.FAQContainer}>
          {FAQContent[FAQArea].map((group) => (
            <Accordion key={group.group} defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  className={classes.FAQSection}
                >{`${group.group}`}</Typography>
              </AccordionSummary>
              {group.questions.map((question, idx) => (
                <Accordion key={question.title}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.FAQTitle}>
                      {question.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className={classes.FAQText}>
                      {question.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Accordion>
          ))}
        </List>
      </Popover>
    </>
  )
}
